export const locale = {
    lang: "pt-BR",
    data: {
        TOOLBAR: {
            CHANGE_PASSWORD: "Trocar Senha",
            LOGOUT: "Deslogar",
            HELP: "Ajuda"
        }
    }
};
